import {useCallback, useState} from "react";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import {alloggiatiAccountMapper} from "../../../mapper/alloggiatiAccount";

import useDialog from "../../../hooks/useDialog";
import {
    useAlloggiatiAccountCreateMutation,
    useAlloggiatiAccountDestroyMutation,
    useAlloggiatiAccountsQuery,
    useAlloggiatiAccountUpdateMutation
} from "../query";


const useAlloggiatiAccounts = () => {
    const alloggiatiAccountsQuery = useAlloggiatiAccountsQuery();
    const alloggiatiAccountCreateMutation = useAlloggiatiAccountCreateMutation();
    const alloggiatiAccountUpdateMutation = useAlloggiatiAccountUpdateMutation();
    const alloggiatiAccountDestroyMutation = useAlloggiatiAccountDestroyMutation();

    const isLoading = alloggiatiAccountsQuery.isLoading;
    const alloggiatiAccounts = alloggiatiAccountsQuery.data?.map(a => alloggiatiAccountMapper(a)) || [];

    const [selectedAccount, setSelectedAccount] = useState({});
    const {askConfirmation} = useFeedbackTools();
    const formCreate = useDialog();
    const formEdit = useDialog();


    const handleEditAccount = useCallback(
        (account) => {
            setSelectedAccount(account);
            formEdit.open();
        },
        [formEdit]
    )

    const handleDelete = useCallback(
        (e, accountId) => {
            e.stopPropagation();
            askConfirmation({
                title: "Eliminare Account",
                description: "Confermi di voler eliminare l'account?",
                confirmationText: 'Ok',
                cancellationText: 'cancella',
                onConfirm: async () => await alloggiatiAccountDestroyMutation.mutateAsync(accountId),
            })
        }, []  // eslint-disable-line react-hooks/exhaustive-deps
    )

    return {
        isLoading: isLoading,
        alloggiatiAccounts,
        createAlloggiatiAccount: alloggiatiAccountCreateMutation.mutateAsync,
        updateAlloggiatiAccount: alloggiatiAccountUpdateMutation.mutateAsync,
        destroyAlloggiatiAccount: alloggiatiAccountDestroyMutation.mutateAsync,
        formCreate,
        formEdit,
        selectedAccount,
        handleEditAccount,
        handleDelete,
    }
}

export default useAlloggiatiAccounts;